<input class="color__picker"
       (colorPickerSelect)="selectColor($event)"
       [(colorPicker)]="color"
       [style.background]="color"/>
